export const objInfomationsTable = [
	{
		classBlock: 'text-bottom',
		classTitle: 'f15 text-initial',
		title: 'BENEFÍCIOS PARA VOCÊ'
	},
	{
		title: 'MAIS CONTROLE',
		classTitle: 'f24 bold',
		subtitle: 'PRÉ-PAGO',
		classParagraph1: 'f14 mb10',
		paragraph1: 'Escolha o valor na primeira recarga e as próximas são automáticas sempre que seu saldo estiver acabando.',
		classParagraph2: 'f14 bold',
		paragraph2: 'Recarga mínima para pagar pedágios e estacionamentos: R$ 50,00',
	},
	{
		classBlock: 'text-top',
		classTitle: 'f24 bold',
		title: 'MAIS PRATICIDADE',
		subtitle: 'PÓS-PAGO',
		classParagraph1: 'f14',
		paragraph1: 'Pague sua fatura mensal após o uso com débito em sua conta ou com cartões de crédito Elo, Mastercard, Visa ou American Express.',
	},
]

export const objInfomative = [
	{
		title: 'Tempo de isenção',
		classInformative: 'text-initial bold calibri'
	},
	{
		title: '9 mensalidades grátis',
		classInformative: 'bold calibri'
	},
	{
		title: '9 mensalidades grátis',
		classInformative: 'bold calibri'
	},
]

export const objPrices = [
	{
		title: 'Taxa de adesão grátis',
		information1: 'Check',
		information2: 'Check',
	},
	{
		title: 'Entrega da tag grátis',
		information1: 'Check',
		information2: 'Check',
	},
	{
		title: 'Sem fidelidade',
		information1: 'Check',
		information2: 'Check',
	}
]
